'use client';

import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import type { PropsWithChildren } from 'react';
import { useCacheKey, useDecisions } from '../../hooks';
import type { LayoutContentProps } from './types';
import './LayoutContent.scss';
export function LayoutContent(t0) {
  const $ = _c(10);
  const {
    layout: t1,
    children
  } = t0;
  const layout = t1 === undefined ? "default" : t1;
  const {
    cookies
  } = useCacheKey();
  const {
    chat_poc
  } = useDecisions();
  let t2;
  if ($[0] !== chat_poc || $[1] !== cookies) {
    t2 = chat_poc && cookies.get("x-petm-chat") === "true";
    $[0] = chat_poc;
    $[1] = cookies;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const open = t2;
  const t3 = `layout-content--${layout}`;
  const t4 = !open;
  let t5;
  if ($[3] !== open || $[4] !== t3 || $[5] !== t4) {
    t5 = cn("layout-content", t3, {
      "layout-content--persistent-drawer-open": open,
      "layout-content--persistent-drawer-closed": t4
    });
    $[3] = open;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== children || $[8] !== t5) {
    t6 = <div data-testid="layout-content" className={t5}>{children}</div>;
    $[7] = children;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}